import DIApi from './_diApi';

class StockAPI extends DIApi {
  controllerName = 'Stocks';
}

export default new StockAPI();
